/**
 * EventPady+ — Platform Admin React Query Hooks
 *
 * All hooks assert SUPER_ADMIN role before enabling queries.
 */
import { useQuery } from '@tanstack/react-query'
import { platformAdminApi } from './api'
import type { PlatformOrgListParams } from '@/types'

export const PLATFORM_ADMIN_KEYS = {
  all:           ['platform-admin'] as const,
  overview:      () => [...PLATFORM_ADMIN_KEYS.all, 'overview'] as const,
  orgs:          (params: PlatformOrgListParams) =>
                   [...PLATFORM_ADMIN_KEYS.all, 'orgs', params] as const,
  orgDetail:     (id: string) =>
                   [...PLATFORM_ADMIN_KEYS.all, 'org', id] as const,
}

export function usePlatformOverview() {
  return useQuery({
    queryKey:  PLATFORM_ADMIN_KEYS.overview(),
    queryFn:   platformAdminApi.getOverview,
    staleTime: 5 * 60 * 1000, // 5 min
  })
}

export function usePlatformOrganizations(params: PlatformOrgListParams = {}) {
  return useQuery({
    queryKey:  PLATFORM_ADMIN_KEYS.orgs(params),
    queryFn:   () => platformAdminApi.listOrganizations(params),
    staleTime: 2 * 60 * 1000, // 2 min
  })
}

export function usePlatformOrganization(id: string) {
  return useQuery({
    queryKey: PLATFORM_ADMIN_KEYS.orgDetail(id),
    queryFn:  () => platformAdminApi.getOrganization(id),
    enabled:  Boolean(id),
  })
}
